export default __webpack_public_path__ + "static/media/ic-closed.1d01a7d6.svg";